module.exports = __webpack_public_path__ + "img/antes_despues_241.e9142f1e.png";